export const getInt = (x) => {
    const parsed = Number.parseInt(x);
    return Number.isNaN(parsed) ? 0 : parsed
}